/** Dedicated PWA app hosts that must stay on their subdomain (no apex 301 collapse). */
export const PWA_INSTALL_SUBDOMAIN_LABELS = [
  'backoffice',
  'api',
  'dev',
  'k9',
  'tics',
  'me',
  'teach',
  'dash',
  'chat',
] as const;

export type PwaInstallSubdomainLabel = (typeof PWA_INSTALL_SUBDOMAIN_LABELS)[number];

export function getPrimarySubdomainLabel(hostname: string): string {
  return hostname.split('.')[0]?.toLowerCase() ?? '';
}

export function isPwaInstallSubdomainLabel(label: string): label is PwaInstallSubdomainLabel {
  return (PWA_INSTALL_SUBDOMAIN_LABELS as readonly string[]).includes(label);
}

export function isMePwaSubdomainHost(hostname: string): boolean {
  return getPrimarySubdomainLabel(hostname) === 'me';
}

export function isTeachPwaSubdomainHost(hostname: string): boolean {
  return getPrimarySubdomainLabel(hostname) === 'teach';
}

export function isChatPwaSubdomainHost(hostname: string): boolean {
  return getPrimarySubdomainLabel(hostname) === 'chat';
}
